import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UsersIDRequestModel } from "../models/UserModels/UsersIDRequestModel";
import { SectorModel } from "../models/SectorModels/SectorModel";
import { SectorDepartmentModel } from "../models/SectorModels/SectorDepartmentModel";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bnsights-utilities-library";

@Injectable({
  providedIn: 'root'
})

export class SectorService {
  ApiUrl = "/api/admin/Sector/"
  constructor(private http: RequestHandlerService) {
  }


  AddSector( AddModel: SectorModel) {
   
    return this.http.post( this.ApiUrl + 'AddSector', AddModel);
  }
  EditSector( EditModel: SectorModel) {
   
    return this.http.post( this.ApiUrl + 'EditSector', EditModel);
  }
  DeleteSector( UsersIDRequestModel: UsersIDRequestModel) {
   
    return this.http.post( this.ApiUrl + 'DeleteSector', UsersIDRequestModel);
  }
  

  AddDepartmentsToSector( AddModel: SectorDepartmentModel) {
   
    return this.http.post( this.ApiUrl + 'AddDepartmentstoSector', AddModel);
  }


  DeleteDepartmentFromSector(DepartmentId:string) {
  
    let params = new HttpParams();
    params = params.append("departmentID",DepartmentId);
    return this.http.post( this.ApiUrl + 'DeleteDepartmentSector', null, params);
  }

  GetSectorInfo(SectorId:string) {
    let params = new HttpParams();
    params = params.append("SectorId",SectorId);
    return this.http.post( this.ApiUrl + 'GetSectorInfo', null, params);
  }
  
  
  
}